import { Input } from '@repo/ui/components'
import { Container } from './Container'

type TextInputProps = {
  name: string
  title: string
  placeholder?: string
  value: string
  setValue: React.Dispatch<React.SetStateAction<string>>
}

export default function TextInput(props: TextInputProps) {
  const hasValue = !!props.value

  const handleReset = () => {
    props.setValue('')
  }

  return (
    <Container
      isResetVisible={hasValue}
      onReset={handleReset}
      hasOptionsSelected={hasValue}
      title={props.title}
    >
      <Input
        name={props.name}
        placeholder={props.placeholder}
        value={props.value}
        onChange={(e) => props.setValue(e.target.value)}
        className="bg-white"
      />
    </Container>
  )
}
